import React, { useMemo } from 'react';
import useGetPcConsoleTimeline from '../../hooks/useGetPcConsoleTimeline';
import CommonPlate from './CommonPlate';
import useGetPcConsoleStats from '../../hooks/useGetPcConsoleStats';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';
import CardLoading from '@/pages/opinion/components/CardLoading';

import './index.scss';
import CardCommon from '@op/components/CardCommon';
import { Segment } from 'tea-component';
import useConsoleDevices from '@op/hooks/useConsoleDevices';
const defaultChannel: Array<'metacritic' | 'opencritic'> = [
  'metacritic',
  'opencritic',
];

const renderPlateList: Array<{
  channel: 'metacritic' | 'opencritic';
  channelName: 'Metacritic' | 'OpenCritic';
  dataKeys: Array<string>;
}> = [
    {
      channel: 'metacritic',
      channelName: 'Metacritic',
      dataKeys: ['meta_score', 'user_score'],
    },
    {
      channel: 'opencritic',
      channelName: 'OpenCritic',
      dataKeys: ['top_critic_average', 'critics_recommend'],
    },
  ];

export default function CriticSites({
  gameInfo,
  scrollBody,
  relativeInfo,
}: {
  gameInfo: any;
  scrollBody: any;
  relativeInfo: any;
}) {
  const {
    loading: initLoading,
    filter,
    changeFilter,
    filterOptions,
  } = useFilterDataHook({
    gameInfo,
    hasHero: true,
    pageName: 'GameStore_Critic_Sites',
  });

  const { tabOptions, deviceLoading, value, setValue } = useConsoleDevices({
    gameInfo,
    relativeInfo,
  });

  const params = useMemo(
    () => ({
      ...filter,
      device: value,
      ...(value && value.toLocaleLowerCase() !== 'pc' ? relativeInfo : {}),
    }),
    [filter, value, relativeInfo],
  );

  const { userScore, userScoreLoading, userScoreApiError } =
    useGetPcConsoleStats({
      keepParams: params,
      channel: defaultChannel,
      needLink: false,
    });

  const {
    userScoreTrendsLoading,
    userScoreTrendsApiError,
    globalTrendsTimeline,
  } = useGetPcConsoleTimeline({
    keepParams: params,
    channel: defaultChannel,
  });

  return (
    <>
      <FilterFixed
        filter={filterOptions}
        scrollBody={scrollBody}
        confirm={(value: any) => {
          changeFilter({
            ...value,
            ...gameInfo,
            channel: ['opencritic', 'metacritic'],
            channel_type: 'comments',
            social_media_by_account: ['99999'],
            social_media_by_keyword: ['99999'],
            external_data_sources: ['99999'],
          });
        }}
        beforeCacheDealwithData={() => false}
        operateShowOptions={['history', 'more']}
      ></FilterFixed>
      <CardCommon
        // empty={tabOptions.length === 0}
        // emptyHeight={560}
        loading={deviceLoading}
        loadingHeight={560}
        contentCard
        className="dbo-page dbo-gamestore dbo-gamestore-pc-wrapper"
      >
        {tabOptions?.length > 0 ? (
          <Segment
            className="segment-light card-slot-segment segment-box"
            value={value}
            onChange={(value) => {
              setValue(value);
            }}
            options={tabOptions}
          />
        ) : (
          <></>
        )}

        <CardLoading loading={initLoading}>
          <div className="critic-sites-wrapper">
            {renderPlateList.map((item) => (
              <CommonPlate
                key={item.channel}
                scoreLoading={userScoreLoading}
                timelineLoading={userScoreTrendsLoading}
                timeline={globalTrendsTimeline?.[item.channel] || []}
                ringData={userScore?.[item.channel] || []}
                filter={filter}
                {...item}
              ></CommonPlate>
            ))}
          </div>
        </CardLoading>
      </CardCommon>
    </>
  );
}
